import React, { useState, useEffect } from "react";
import Header from "./../../components/Header";
import THero from "./THero";
import Utility from "./Utility";
import Supply from "./Supply";
import "./Tendies.sass";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function Tendies() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  const [headerBg, setHeaderBg] = useState(
    "linear-gradient(180deg, rgba(175, 88, 129, 0.85) 0%, rgba(175, 88, 129, 0.85)"
  );
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    if (windowDimensions.width < 576) {
      setHeaderBg(
        "linear-gradient(180deg, rgba(175, 88, 129, 0.85) 0%, rgba(175, 88, 129, 0.85)"
      );
    } else {
      setHeaderBg(
        "linear-gradient(0deg, rgba(55, 36, 65, 1) 0%, rgba(55, 36, 65, 1) 100%)"
      );
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [windowDimensions.width]);

  return (
    <div className="tendies">
      <Header bg={headerBg} />
      <THero />
      <Utility />
      <Supply />
    </div>
  );
}
